import { observer } from 'mobx-react-lite';

import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';

/**
 * 해와오의 메타 태그 설정을 위한 컴포넌트
 * - 각 페이지 컴포넌트에서 추가한다
 */
export const MetaHeader = observer(
    ({
        title,
        description,
        image,
        keepTitle = false,
    }: {
        /**
         * 페이지 제목
         * - 자동으로 제목 뒤에 서비스명을 붙여줌
         * - 제목 뒤에 서비스명 붙이지 않으려면 keepTitle 을 true 로 설정
         */
        title?: string;
        /**
         * 페이지 설명.
         */
        description?: string;
        /**
         * 페이지 이미지.
         */
        image?: string;
        keepTitle?: boolean;
    }) => {
        const baseUrl = 'https://haewao.com';
        const location = useLocation();
        const pathname = location.pathname || '';

        const serviceTitle = '해와오';

        // 제목 뒤에 서비스명을 붙여줌
        let refinedTitle = title;

        if (title && title !== serviceTitle && !keepTitle) {
            refinedTitle = `${title} - ${serviceTitle}`;
        }

        // 태그 내에 들어갈 땐 공백을 정리해줌
        const refinedDescription = description ? description.replace(/\s+/g, ' ') : '';

        // 나중에 채운다
        const author = '';

        return (
            <Helmet>
                <title>{refinedTitle}</title>
                {refinedDescription && <meta name="description" content={refinedDescription} />}

                <link rel="canonical" href={`${baseUrl}${pathname}`} />

                {title && <meta property="og:title" content={refinedTitle} />}
                {refinedDescription && (
                    <meta property="og:description" content={refinedDescription} />
                )}
                {image && <meta property="og:image" content={image} />}

                <meta name="robots" content={'all'} />
                <meta name="apple-mobile-web-app-title" content={serviceTitle} />
                <meta name="application-name" key="application-name" content={serviceTitle} />
                {author && <meta name="author" key="author" content={author} />}

                <meta name="twitter:card" key="twitter:card" content={'summary'} />
                <meta name="twitter:url" key="twitter:url" content={`${baseUrl}${pathname}`} />
                <meta name="twitter:title" key="twitter:title" content={refinedTitle} />
                <meta
                    name="twitter:description"
                    key="twitter:description"
                    content={refinedDescription}
                />
                {author && <meta name="twitter:creator" key="twitter:creator" content={author} />}
                {image && <meta name="twitter:image" key="twitter:image" content={image} />}

                <meta property="og:type" key="og:type" content="website" />
                <meta property="og:title" key="og:title" content={refinedTitle} />
                <meta property="og:description" key="og:description" content={refinedDescription} />
                <meta property="og:site_name" key="og:site_name" content={serviceTitle} />
                <meta property="og:url" key="og:url" content={`${baseUrl}${pathname}`} />
                {image && <meta property="og:image" key="og:image" content={image} />}
            </Helmet>
        );
    },
);

export default MetaHeader;
